import React, {useEffect} from 'react';
import {Spinner} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ModalActivarPresupuesto = (props) => {
	/* Destructuring the props object. */
	const {
		EstadoActivacion,
		cerrarModalActivarPresupuesto,
		enviarAceptacion,
		titulo,
		mensaje1,
		mensaje2,
	} = props;

	return (
		<>
			<div className='modalEnviarPresupuesto'>
				<div className='contentModalEnviarPresupuesto'>
					{EstadoActivacion === 0 ? (
						<>
							<div className='infoContentModalEnviarPresupuesto'>
								<div className='titleInfoContentModalEnviarPresupuesto'>
									<h3>{titulo}</h3>
								</div>
								<div className=''>{mensaje1}</div>
							</div>
							<div className='botonesEnviarPresupuesto'>
								<div
									className='button borrarCuenta'
									onClick={cerrarModalActivarPresupuesto}
								>
									Cancelar
								</div>
								<div
									className='button'
									onClick={enviarAceptacion}
								>
									Aceptar
								</div>
							</div>
						</>
					) : EstadoActivacion === 1 ? (
						<Spinner />
					) : (
						<div className='infoContentModalEnviarPresupuesto'>
							<div>{mensaje2}</div>
							<div className='centrador'>
								<div
									className='button'
									onClick={cerrarModalActivarPresupuesto}
								>
									Cerrar
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
